export const INITIAL_STATE = {
  type: null,
  payload: null
}

export const reducer = (_, action) => action
